import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

interface UnsavedChangesDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function UnsavedChangesDialog({
  open,
  onCancel,
  onConfirm,
}: UnsavedChangesDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onCancel}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t('domain.termine.sheet.unsavedChanges.unsavedChangesTitle')}
          </DialogTitle>
          <DialogDescription>
            {t('domain.termine.sheet.unsavedChanges.unsavedChangesDescription')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={onConfirm} variant={'outline'}>
            {t('domain.termine.sheet.unsavedChanges.unsavedChangesAbort')}
          </Button>
          <Button onClick={onCancel}>
            {t('domain.termine.sheet.unsavedChanges.unsavedChangesContinue')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
